import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type Props = {
  show: boolean;
  value: string;
  onChange: (value: string) => void;
  onApply: () => void;
  onClose: () => void;
};

export default function MailImageLinkModal({
  show,
  value,
  onChange,
  onApply,
  onClose
}: Props) {

  const { t } = useTranslation(['labels', 'mailManager']);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('add_link', { ns: 'mailManager' })}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group>
          <Form.Label>{t('link_url', { ns: 'mailManager' })}</Form.Label>
          <Form.Control
            type="url"
            placeholder="https://example.com"
            value={value}
            onChange={e => onChange(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t('close', { ns: 'labels' })}
        </Button>
        <Button variant="primary" onClick={onApply}>
          {t('save', { ns: 'mailManager' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
